export const FETCH_INITIAL_NOTES_DATA_REQUEST = "FETCH_INITIAL_NOTES_DATA_REQUEST";
export const FETCH_INITIAL_NOTES_DATA_SUCCESS = "FETCH_INITIAL_NOTES_DATA_SUCCESS";
export const FETCH_INITIAL_NOTES_DATA_FAILURE = "FETCH_INITIAL_NOTES_DATA_FAILURE";
